import { type Enum } from '@webapp/infrastructure/types/Enum'

// Action codes on embedded travel `logs[]` entries
export const TravelApprovalLogActions = {
  REQUEST: 0,
  FINAL_APPROVE: 1,
  DENY: 2,
  PURCHASE: 19,
} as const

export type TravelApprovalLogActionEnum = Enum<typeof TravelApprovalLogActions>
